import UserGroupIcon from './component'

export default UserGroupIcon
